import {twMerge} from '@sdox/utils'

import {Avatar} from '../Avatar'

import type {ComponentProps} from 'react'

export interface CustomerIdentityProps extends ComponentProps<'div'> {
  avatarHref?: string
  name?: string
  title?: string
  text?: string
  size?: 'small' | 'medium' | 'large'
}

const sizes = {
  small: 'gap-2',
  medium: 'gap-2',
  large: 'gap-4',
}

export const CustomerIdentity = ({
  avatarHref,
  className,
  name,
  title,
  text,
  size = 'medium',
  children,
  ...restProps
}: CustomerIdentityProps) => (
  <div
    className={twMerge('flex select-none items-center', sizes[size], className)}
    {...restProps}
  >
    <Avatar
      src={avatarHref}
      size={size}
    />
    <div className={twMerge('flex flex-1 items-start', title || text ? 'flex-col-reverse' : 'flex-col')}>
      {text ? <span className={'text-sm leading-tight'}>{text}</span> : <span>{title}</span>}
      {name && <span className={'font-bold leading-tight'}>{name}</span>}
      {children}
    </div>
  </div>
)
